import * as yup from 'yup';
import { z } from 'zod';

export type PublishablePrivacyControls = z.infer<typeof PublishablePrivacyControlsSchema>;

export const PublishablePrivacyControlsSchema = z.object({
  active: z.boolean(),
  criteria: z.object({
    connectionType: z.array(z.string()).optional(),
  }),
});

/**
 * @deprecated this schema is deprecated and will be removed in the future
 */
const criteriaSchemaDeprecated: yup.SchemaOf<PublishablePrivacyControls['criteria']> = yup.object({
  connectionType: yup.array().of(yup.string()).optional(),
});

/**
 * @deprecated this schema is deprecated and will be removed in the future
 */
export const PublishablePrivacyControlsSchemaDeprecated: yup.SchemaOf<PublishablePrivacyControls> = yup.object({
  active: yup.boolean().required(),
  criteria: criteriaSchemaDeprecated,
});
